import React from 'react'
import { Modal } from 'react-bootstrap';

const SettingDeleteAccount = ({
    showModal,
    closeModal,
    getLangTranslation,
    handleDelete,
    load
}) => {
    return (
        <>
            <Modal
                show={showModal}
                size="sm"
                className="custom-modal blur-bg"
                centered
            >
                <Modal.Header>
                    <div className="border-0 pb-0 d-flex justify-content-between w-100">
                        <h6 className="modal-title text-blue-900">{getLangTranslation('SETTINGS_DELETE_MY_ACCOUNT','Delete my account')}</h6>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
                    </div>
                </Modal.Header>
                <Modal.Body className='py-1 px-4'>
                    <div className="modal-body">
                        <h5 className="text-center mb-3">
                            {getLangTranslation('ARE_YOU_SURE_WANT_DELETE_THIS_PARENT', 'Are you sure want to delete this parent account ?')}
                        </h5>
                        {/* <p className="mb-6 text-center">
                            Lorem ipsum dolor sit amet consectetur. Vestibulum sagittis odio
                            id sed tortor praesent.
                        </p> */}
                        <div className="grid gap-3">
                            <button
                                className="btn btn-outline-primary g-col-6"
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={closeModal}
                                disabled={load}
                            >
                                <span className="btn-upper-case">{getLangTranslation('CANCEL', 'Cancel')}</span>
                            </button>
                            <button
                                className="btn btn-primary g-col-6"
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleDelete}
                                disabled={load}
                            >
                                <span className="btn-upper-case">
                                    {getLangTranslation('DELETE_CHILD_DELETE', 'Delete')}
                                </span>
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SettingDeleteAccount